__turbopack_context__.v({
  "language": "Languages-module-scss-module__UIz-Gq__language",
  "language--active": "Languages-module-scss-module__UIz-Gq__language--active",
  "languages": "Languages-module-scss-module__UIz-Gq__languages",
});
